"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZERO_BOUNCE_EMAIL_SUB_STATUS = void 0;
// THIS IS ZERO BOUNCE API CONSTANTS, please don't change
exports.ZERO_BOUNCE_EMAIL_SUB_STATUS = {
    ALIAS_ADDRESS: 'aliasAddress',
    ANTISPAM_SYSTEM: 'antispamSystem',
    DOES_NOT_ACCEPT_EMAIL: 'doesNotAcceptMail',
    EXCEPTION_OCCURRED: 'exceptionOccurred',
    FAILED_SMTP_CONNECTION: 'failedSmtpConnection',
    FAILED_SYNTAX_CHECK: 'failedSyntaxCheck',
    FORCIBLE_DISCONNECT: 'forcibleDisconnect',
    GLOBAL_SUPPRESSION: 'globalSuppression',
    GREY_LISTED: 'greylisted',
    LEADING_PERIOD_REMOVED: 'leadingPeriodRemoved',
    MAIL_SERVER_DID_NOT_RESPOND: 'mailServerDidNotRespond',
    MAIL_SERVER_TEMPORARY_ERROR: 'mailServerTemporaryError',
    MAILBOX_QUOTA_EXCEEDED: 'mailboxQuotaExceeded',
    MAILBOX_NOT_FOUND: 'mailboxNotFound',
    NO_DNS_ENTRIES: 'noDnsEntries',
    POSSIBLE_TRAP: 'possibleTrap',
    POSSIBLE_TYPO: 'possibleTypo',
    ROLE_BASED: 'roleBased',
    ROLE_BASED_CATCH_ALL: 'roleBasedCatchAll',
    TIMEOUT_EXCEEDED: 'timeoutExceeded',
    UNROUTABLE_IP_ADDRESS: 'unroutableIpAddress',
    DISPOSABLE: 'disposable',
    TOXIC: 'toxic',
    DEFAULT: ''
};
//# sourceMappingURL=zeroBounceEmailSubStatus.js.map